module.exports = __webpack_public_path__ + "img/logo4.4e609fe6.png";